/**
 *
 * PriceDisclamer
 *
 */
import React from 'react';
import { Box, Icon } from '@eriksdigital/atomic-ui/components';
import { TooltipIcon } from '@eriksdigital/atomic-ui/components/Icons';
import { FormattedMessage } from 'react-intl';
import { Text } from 'components/Item/styles';
import { parseCurrency } from 'utils/currencyUtils';

export function PriceDisclamer(props: any) {
  const { netValue } = props;
  const parsedNetValue = parseCurrency(netValue);
  const shouldShowMinValueDisclaimer = parsedNetValue <= 25;
  return (
    <Box marginBottom="sp24">
      <Box display="flex" alignItems="center">
        <Box display="flex" marginRight="sp8" alignSelf="end">
          <Icon as={TooltipIcon} color="#646972" size="sz16" />
        </Box>
        <Box>
          <FormattedMessage
            id='price.disclaimer'
            defaultMessage='Custom made articles can not be returned'
            description='Label for price configured disclaimer'
          />
        </Box>
      </Box>
      {shouldShowMinValueDisclaimer && (
        <Box display="flex" alignItems="center">
          <Box display="flex" marginRight="sp8">
            <Icon as={TooltipIcon} color="#646972" size="sz16" />
          </Box>
          <Box>
            <Text>** </Text>
            <FormattedMessage
              id='price.disclaimer.minValue'
              defaultMessage='Minimal value per configuration'
              description='Label for minimal price configured disclaimer'
            />
            {' '}{netValue}
          </Box>
        </Box>
      )}
    </Box>
  );
}
